import React, { FC } from 'react';
import {
  BorderLinearProgress, IProps,
} from './interfaces';
import { Colors } from '../../../constants';
import { VaultUploadStatus } from '../../../state/vaultUploadDialog';

const ProgressBar: FC<IProps> = (props: IProps) => {
  const { stage, percent } = props;
  let progress: number = 0;
  let barValue: number = 0;
  switch (percent) {
    case (null):
      progress = 0;
      break;
    case (undefined):
      progress = 0;
      break;
    default:
      progress = parseInt(percent, 10);
      if (progress > 100) {
        progress = 100;
      }
      break;
  }
  switch (stage) {
    case (VaultUploadStatus.PreProcessing):
      barValue = (0.5 * progress);
      break;
    case (VaultUploadStatus.Uploading):
      barValue = 50 + (0.5 * progress);
      break;
    case (VaultUploadStatus.Complete):
      barValue = 100;
      break;
    case (VaultUploadStatus.CheckTranscode):
      barValue = 100;
      break;
    default:
      barValue = 0;
      break;
  }
  return (
    <BorderLinearProgress
      variant="determinate"
      value={barValue}
      sx={{
        backgroundColor: `rgb(${Colors.PRIMARY},0.4)`,
        '& .MuiLinearProgress-bar': {
          backgroundColor: stage === 'Complete' ? Colors.SUCCESS : Colors.PRIMARY,
        },
      }}
    />
  );
};
export default ProgressBar;
